define([
	"csi/_base/underscore",
	"csi/core/ExtendedPath",
	"csi/reflection"
], function(_, ExtendedPath, reflection) {

	return {
		getMappingKey: function(/*Node*/nodeConfigurableAttribute) {
			// summary: get the mapping key based on the ConfigurableAttribute

			// build a key in the format of DataPoint
			var path = new ExtendedPath("Style");
			var rc = reflection.getClass(nodeConfigurableAttribute.ReflectionAttributeOwner);
			if (rc.isDerivedFrom("ProductAttributes"))
				path.addRelationStep("Attributes", "StyleAttributes");
			if (rc.isDerivedFrom("ProductSourcing"))
				path.addRelationStep("ProductSourcing", "StyleSourcing");

			var name = nodeConfigurableAttribute.$Name;
			var index = name.indexOf("/");
			if (index >= 0)
				name = name.substring(index + 1);

			var key = name + ":" + path.toString() + ":0";

			return key;
		},

		findMappingKeyInSettings: function(/*Node*/nodeSettings, /*String*/key) {
			var index = _.indexOf(nodeSettings.ProductAttributeMappingKeys, key);
			return index;
		}
	};
});